import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import React, { useState, useEffect } from 'react';
import Input from './input';

const InputMaxLen = React.forwardRef(({ max = 100, onChange, value, ...props }, ref) => {
  const [charactersLeft, setCharactersLeft] = useState(max);
  const [acceptedValue, setAcceptedValue] = useState(null);

  useEffect(() => {
    if (value) {
      setAcceptedValue(value);
      setCharactersLeft(max - value.length);
    }
  }, [value]);

  const onValueChanged = (e) => {
    if (max >= e.target.value.length) {
      setAcceptedValue(e.target.value);
      setCharactersLeft(max - e.target.value.length);
      onChange(e);
    }
  };

  return (
    <>
      <Input ref={ref} onChange={onValueChanged} value={acceptedValue} {...props} />
      <FormattedMessage id='typesForm.labels.CHARACTERS_LEFT' values={{ amount: charactersLeft }} />
    </>
  );
});

InputMaxLen.propTypes = {
  max: PropTypes.number,
  onChange: PropTypes.func,
  value: PropTypes.string,
};

export default InputMaxLen;
